<template>
    <ContactForm
        v-model="formData"
        :class="$style.contactForm_override"
        :submitStatus="submitStatus"
        :withCheckboxes="!!firstCheckboxText"
        @formReset="resetForm"
        @turnstileReady="setTurnstileToken"
        @submit="handleSubmit"
    >
        <template #firstCheckboxText>
            <component :is="parseMarkdown(firstCheckboxText || '')" />
        </template>

        <template #secondCheckboxText>
            <component :is="parseMarkdown(secondCheckboxText || '')" />
        </template>
    </ContactForm>
</template>
<script setup lang="ts">
import { compiler as md } from 'markdown-to-jsx'
import { computed, h } from 'vue'
import { useRoute } from 'vue-router'

import ContactForm from '@/components/ContactForm/ContactForm.vue'
import { useContactForm } from '@/components/ContactForm/use-contact-form'
import Link from '@/components/Link.vue'

defineProps<{
    firstCheckboxText?: string | undefined
    secondCheckboxText?: string | undefined
}>()

const route = useRoute()

const additionalRequestParamsRef = computed(() => ({ page: route.fullPath }))
const { formData, submitStatus, resetForm, handleSubmit, setTurnstileToken } = useContactForm({
    additionalRequestParamsRef,
})

function parseMarkdown(src: string) {
    return md(src, {
        createElement: (tag, rawProps, ...children) => {
            const { className, ...mdProps } = rawProps
            switch (tag) {
                case 'a': {
                    return h(
                        Link,
                        {
                            externalTo: mdProps.href,
                            color: 'purple-600',
                            target: mdProps.target || '_blank',
                        },
                        {
                            default: () => children,
                        },
                    )
                }

                default:
                    return h(tag, mdProps, children)
            }
        },
    })
}
</script>
<style module>
.contactForm_override {
    margin: 48px 0;
}
</style>
